import * as ProfileActionCreators from '~/store/action-creators/profile';

const actionCreators = {
  ...ProfileActionCreators,
};

export default actionCreators;
